<template>
  <section class="py-5 bg-faded bg-light" id="prevencao">
    <div class="container-fluid text-center">
      <div class="row align-items-center justify-content-center bg-aquamarine" style="height:15vh;">
        <div class="col-md-12">
          <h1 class="text-white">PREVENÇÃO CORONAVÍRUS</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12 ">
                <img class="img-fluid" src="@/assets/imagens/prevencao_01.png" alt="Prevenção 01">
              </div>
              <!--<div class="col-md-12 col-xl-6"><img class="img-fluid rounded-circle p-3"
                                                   src="imagens/prevencao_02.png" alt="Prevenção 02">
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Bloco3Prevencao"
}
</script>

<style>

</style>